import { FormControl, InputLabel, MenuItem, Select, Skeleton, TextField } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { toZonedTime } from 'date-fns-tz'
import { enUS } from 'date-fns/locale'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toDayjs } from 'utils/functions/doformsDateUtil'
import { getUserTimeZone } from 'utils/functions/helpers'

function GeoMapFilters({
	vehicleList,
	vehicleName,
	vehicleLoading,
	fromDate,
	toDate,
	disableFilters,
	onFilters,
}) {
	const { t } = useTranslation('common')
	const [locale, setLocale] = useState(enUS)
	const displayFromDate = useMemo(() => {
		return toDayjs(fromDate)
	}, [fromDate])

	const displayToDate = useMemo(() => {
		return toDayjs(toDate)
	}, [toDate])
	const handleFromDateChange = (newValue) => {
		if (!newValue?.isValid()) {
			onFilters?.('fromDate', null)
			return
		}

		// const localDate = toZonedTime(newValue.format('MM/DD/YYYY HH:mm:ss'), getUserTimeZone())

		onFilters?.('fromDate', newValue.toDate())
	}

	const handleToDateChange = (newValue) => {
		if (!newValue?.isValid()) {
			onFilters?.('toDate', null)
			return
		}

		// const localDate = toZonedTime(newValue.format('MM/DD/YYYY HH:mm:ss'), getUserTimeZone())

		onFilters?.('toDate', newValue.toDate())
	}

	return (
		<>
			{!vehicleLoading ? (
				<FormControl sx={{ minWidth: 120 }} size="small" disabled={disableFilters}>
					<InputLabel id="vehicle-select-small-label">{t('common:input.vehicleName')}</InputLabel>
					<Select
						labelId="vehicle-select-small-label"
						id="vehicle-select-small"
						value={vehicleName || ''}
						label={t('common:input.vehicleName')}
						onChange={(e) => {
							onFilters?.('vehicleName', e.target.value)
						}}
					>
						<MenuItem value="">
							<em>None</em>
						</MenuItem>
						{vehicleList?.length > 0 &&
							vehicleList.map((vehicle) => (
								<MenuItem value={vehicle.name} key={vehicle.name}>
									{vehicle.name}
								</MenuItem>
							))}
					</Select>
				</FormControl>
			) : (
				<Skeleton variant="rectangular" height={45} sx={{ minWidth: 120 }} />
			)}

			<LocalizationProvider dateAdapter={AdapterDayjs} locale={locale}>
				<DatePicker
					componentsProps={{
						actionBar: {
							actions: ['clear'],
						},
					}}
					id="map-date"
					label={t('common:input.fromDate')}
					disabled={disableFilters}
					value={displayFromDate}
					maxDate={toDayjs(locale.maxDate)}
					onChange={handleFromDateChange}
					onAccept={handleFromDateChange}
					slotProps={{
						textField: {
							InputProps: {
								size: 'small',
								variant: 'outlined',
								error: false,
							},
							onChange: (e) => {
								if (!e?.isValid()) return
								handleFromDateChange(e)
							},
						},
					}}
				/>
			</LocalizationProvider>

			<LocalizationProvider dateAdapter={AdapterDayjs} locale={locale}>
				<DatePicker
					componentsProps={{
						actionBar: {
							actions: ['clear'],
						},
					}}
					id="map-date"
					label={t('common:input.toDate')}
					disabled={disableFilters}
					value={displayToDate}
					maxDate={toDayjs(locale.maxDate)}
					onChange={handleToDateChange}
					onAccept={handleToDateChange}
					slotProps={{
						textField: {
							InputProps: {
								size: 'small',
								variant: 'outlined',

								// Turn off the error when the user clears the date
								error: false,
							},
							onChange: (e) => {
								if (!e?.isValid()) return
								handleToDateChange(e)
							},
						},
					}}
				/>
			</LocalizationProvider>
		</>
	)
}

export default GeoMapFilters
